const query = (id, isPreview) => `
{
    imageHeroBanner(id: "${id}", preview: ${isPreview}) {
        heading
        description
        backLink {
          label
          title
          url
          target
          scrollToElementId
          ariaLabel
          image {
            title
            description
            url
            width
            height
          }
        }
         underlineText
        images {
          internalTitle
          altText
          imageDesktop {
            title
            description
            url
            width
            height
          }
          imageMobile {
            title
            description
            url
            width
            height
          }
          bgDesktop {
            title
            description
            url
            width
            height

          }
          bgMobile {
            title
            description
            url
            width
            height
          }
        }
        video {
          title
          youtubeVideoId
          posterImage {
            altText
            imageMobile {
              title
              description
              url
              width
              height
            }
            imageDesktop {
              title
              description
              url
              width
              height
            }
          }
          isModal
          enableWatchLater
          isImageToggle
          isButtonBlack
          variant
          isCaption
          isCareerPage
        }
        backLink {
          label
          title
          url
          target
          scrollToElementId
          ariaLabel
          image {
            title
            description
            url
            width
            height
          }
          gaEventClass
          gaEventLabel
        }
        link {
          label
          title
          url
          target
          scrollToElementId
          image {
            title
            description
            url
            width
            height
          }
          gaEventClass
          gaEventLabel
          ariaLabel
        }
        languageLinkCollection {
          items{
           label
            url
            target
            title
            gaEventClass
            gaEventLabel
          }
        }
        variant
        isJobSearch
        countryCode
        countryData
        jobFamilyFilter
  }
}
`
module.exports = { query }
